import { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Pricing.scss";
import { useParams, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Tag } from "../../utils/GTMPageTag";
import OrderFormMailbox from "../../components/order/OrderFormMailbox";
import OrderFormPhone from "../../components/order/OrderFormPhone";

import { useTranslation } from "react-i18next";

const PricingMailbox = (props) => {
  Tag("PricingMailbox")
  const { t } = useTranslation(["common","pricing"]);

  const defaultTab = props.tab ?? 'geschaeftsadresse';
  const { country, city, type, area } = useParams();


  const [selectTab, setSelectedTab] = useState(defaultTab);
  const handleTabSelect = (tab_type) => {
    setSelectedTab(tab_type);
    if(!( 
      country !== undefined && country !== "" && 
      city !== undefined && city !== "" && 
      type !== undefined && type !== "" &&
      area !== undefined && area !== ""
    )){
      if( tab_type === 'geschaeftsadresse' ){
        window.history.replaceState({}, null, props.link+'/geschaeftsadresse');
      }else if( tab_type === 'telefonnummer' ){
        window.history.replaceState({}, null, props.link+'/telefonnummer');
      }
    }
  };

  return (
    <div id="PricingMailbox" className="MainbBody">
      <div className="PricelistBanner">
        <Container>
          <Row>
            <Col sm={12}>
              <div>
                <h3>{t('pricing:order.title')}</h3>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="PricelistBody">
        <Container>
          <Row>
            <Col sm={12}>
              <div>
                <h3>{t('pricing:order.page_heading')}</h3>
              </div>
            </Col>
          </Row>
          <Row className="PricelistTab">
            <Col sm={12}>
              <Tabs
                defaultActiveKey={defaultTab}
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={handleTabSelect}
              >
                <Tab
                  eventKey="geschaeftsadresse"
                  title={t('pricing:order.tab_1_text')}
                >
                  <div className="PlanScetion">
                    <Container className="">
                      <Row>
                        <Col sm={12}>
                          <div className="ScetionTitel mb-0">
                            <div>
                              <h2>{t('pricing:order.tab_1_product_heading')}</h2>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  
                  {selectTab  === 'geschaeftsadresse' ?
                    <OrderFormMailbox navigateLink={props.link+'/geschaeftsadresse'} />
                    : null
                  }
                  <Link className="BtnSubmit btn btn-primary mt-4" to='/faq'>{t('pricing:order.faq')}</Link>
                </Tab>
                <Tab
                  eventKey="telefonnummer"
                  title={t('pricing:order.tab_2_text')}
                >
                  <div className="PlanScetion">
                    <Container className="">
                      <Row>
                        <Col sm={12}>
                          <div className="ScetionTitel mb-0">
                            <div className="ScetionTitel mb-0">
                              <div>
                                <h2>{t('pricing:order.tab_2_heading')}</h2>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                  {selectTab  === 'telefonnummer' ?
                    <OrderFormPhone navigateLink={props.link+'/telefonnummer'}/>
                    : null
                  }
                  <Link className="BtnSubmit btn btn-primary mt-4" to='/faq'>{t('pricing:order.faq')}</Link>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PricingMailbox;
